import React from "react"
import VariantReader from "aldoo-ra/VariantReader"
import Checkbox from "aldoo-ra/Checkbox"
import { twMerge } from "tailwind-merge"

const RadioGroup = ({
  options = [],
  value,
  onChange,
  variant = "default",
  styleOverrides = {},
  className = "",
  name,
  disabled = false,
  orientation = "vertical", // vertical or horizontal
  size = "medium", // small, medium, large
  error = "",
  label = "",
  required = false,
}) => {
  // Get styles from variant
  const variants = VariantReader.useVariant({
    componentName: "RadioGroup",
    variant,
    styleOverrides,
  })

  // Generate unique name if not provided
  const groupName =
    name || `radio-group-${Math.random().toString(36).substring(2, 11)}`

  const handleChange = (optionValue, option) => {
    if (!disabled && !option.disabled && onChange) {
      onChange(optionValue)
    }
  }

  const getOptionClassName = (option, isSelected) => {
    const isDisabled = disabled || option.disabled

    return twMerge(
      variants.option,
      isSelected ? variants.optionSelected : variants.optionUnselected,
      isDisabled ? variants.optionDisabled : variants.optionEnabled,
      size === "small" ? variants.optionSmall : "",
      size === "large" ? variants.optionLarge : "",
      option.className || ""
    )
  }


  return (
    <div
      className={twMerge(
        variants.container,
        orientation === "horizontal" ? variants.containerHorizontal : "",
        error ? variants.containerError : "",
        className
      )}
      role="radiogroup"
      aria-labelledby={label ? `${groupName}-label` : undefined}
      aria-required={required}
      aria-invalid={!!error}
    >
      {/* Label */}
      {label && (
        <label id={`${groupName}-label`} className={variants.label}>
          {label}
          {required && <span className={variants.required}>*</span>}
        </label>
      )}

      {/* Options */}
      <div
        className={twMerge(
          variants.optionsContainer,
          orientation === "horizontal"
            ? variants.optionsContainerHorizontal
            : ""
        )}
      >
        {options.map((option, index) => {
          const isSelected = option.value === value
          const isDisabled = disabled || option.disabled
          const optionId = `${groupName}-option-${index}`

          return (
            <div
              key={option.value || index}
              className={getOptionClassName(option, isSelected)}
            >
              <Checkbox
                variant={variant === "admin" ? "aqua" : "default"}
                isOn={isSelected}
                onChange={() => handleChange(option.value, option)}
                label={option.label}
                disabled={isDisabled}
                name={groupName}
                className={variants.checkboxWrapper}
              />
              {option.description && (
                <span
                  id={`${optionId}-desc`}
                  className={variants.optionDescription}
                >
                  {option.description}
                </span>
              )}
            </div>
          )
        })}
      </div>

      {/* Error message */}
      {error && (
        <p className={variants.errorText} role="alert">
          {error}
        </p>
      )}
    </div>
  )
}

export default RadioGroup
